import config from '../config';

export const isMakeOrgMember = (email?: string | null): boolean =>
    !!email?.toLowerCase().endsWith(config.makeOrganizationEmailDomain);
